import { resolve } from "../Routes/RoutesContext";
import { useLocalizedLocation } from "../Utils/localizedLocation";

export const useCurrentRoute = () => {
  const location = useLocalizedLocation();

  if (!location) return null;

  const route = resolve(location.pathname);

  return { ...route, location };
};
